




























import * as _ from 'lodash';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

import type { IsValidAddress } from '@/api-svc-types';
import { BaseVue } from '@/BaseVue';

import UiCheckbox from '../../components/ui/UiCheckbox.vue';
import UiSelect2 from '../../components/ui/UiSelect2.vue';
import UiTextEdit from '../../components/ui/UiTextEdit.vue';
import { validWalletAddress } from '../../queries/walletQueries';

@Component({
  components: {
    UiTextEdit,
    UiSelect2,
    UiCheckbox,
  },
})
export default class BlockchainAddressInput extends BaseVue {
  public apiKey = '';
  public apiSecret = '';
  public exchangeContactId = '';
  public location = 'standard';
  public isValid = false;
  public locations = {
    'Ftx.com': 'standard',
    'Ftx.us': 'us',
  };

  public syncSubAccounts = false;

  public debouncedValidate = _.debounce(this.validateForm.bind(this), 1000);

  public async validateForm() {
    // TODO
  }

  public get contacts() {
    const contacts = this.$store.getters['contacts/ENABLED_CONTACTS'];
    const res: any = {};
    contacts.forEach((contact: any) => (res[contact.name] = contact.id));
    return res;
  }

  public get contactsArray() {
    const contacts = this.$store.getters['contacts/ENABLED_CONTACTS'];
    return contacts.map((contact: any) => ({ id: contact.id, label: contact.name }));
  }

  @Watch('apiKey')
  @Watch('apiSecret')
  @Watch('exchangeContactId')
  @Watch('location')
  @Watch('syncSubAccounts')
  public onWalletTypeChanged() {
    this.debouncedValidate();
    this.$emit('data', {
      createFtx: {
        apiKey: this.apiKey,
        apiSecret: this.apiSecret,
        exchangeContactId: this.exchangeContactId,
        location: this.location,
        syncSubAccounts: this.syncSubAccounts,
      },
    });
  }

  @Watch('isValid')
  public validChanged() {
    this.$emit('valid', this.isValid);
  }
}
